import React, { useContext, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { Alert, Row, Table, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import BookItem from "./BookItem";

const BookList = observer(({ onBookSelect, setActiveComponent }) => {
    const { book } = useContext(Context);
    const [viewMode, setViewMode] = useState(localStorage.getItem("bookViewMode") || "cards");

    const handleClick = (b) => {
        book.setSelectedCurrentUserBook(b);
        onBookSelect(b);
        setActiveComponent("BookFull");
    };

    const books = book.currentuserbooks || [];

    const handleViewModeChange = (val) => {
        setViewMode(val);
        localStorage.setItem("bookViewMode", val);
    };

    return (
        <>
            <div className="card justify-content-start text-start start-0 mt-2 mb-1 p-2 small bg-white rounded">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <h6 className="text-success mb-0 ms-1">List of Books / Products</h6>
                    <ToggleButtonGroup
                        type="radio"
                        name="viewMode"
                        value={viewMode}
                        onChange={handleViewModeChange}
                        size="sm"
                    >
                        <ToggleButton id="view-cards" variant="outline-success" value="cards">
                            📚 Cards
                        </ToggleButton>
                        <ToggleButton id="view-table" variant="outline-success" value="table">
                            📋 Table
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>

            {books.length === 0 ? (
                <Alert variant="light" className="text-muted text-center mt-2">
                    Unfortunately, you haven't added any books yet, so this section is currently empty.<br />
                    Add your first book to the platform to make it appear here.
                </Alert>
            ) : viewMode === "cards" ? (
                <Row className="d-flex justify-content-start p-0">
                    {books.map(b => (
                        <BookItem
                            key={b.id}
                            thisBook={b}
                            onClick={() => handleClick(b)}
                        />
                    ))}
                </Row>
            ) : (
                <div className="card text-start align-content-center shadow-sm mt-2 mb-0 p-3" >
                    <div className="mt-0">
                         {/* 📱 Обёртка для горизонтального скролла */}
                        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                            <Table
                                striped
                                bordered
                                hover
                                size="sm"
                                className="shadow-sm rounded small mb-0"
                                style={{ minWidth: '890px' }} // минимальная ширина для корректного скролла
                            >
                                <thead className="table-light small text-muted">
                                <tr>
                                    <th className="text-center fst-italic">#</th>
                                    <th className="text-start fst-italic">Title</th>
                                    <th className="text-start fst-italic">Subtitle / Manufacturer</th>
                                    <th className="text-start fst-italic">Author / Seller</th>
                                    <th className="text-center fst-italic">Language</th>
                                    <th className="text-center fst-italic">Added</th>
                                    <th className="text-center fst-italic">Status</th>
                                    <th className="text-center fst-italic">Reviews</th>
                                    <th className="text-center fst-italic">Rating</th>
                                </tr>
                                </thead>
                                <tbody>
                                {books.map((b, index) => {
                                    const bookRatingInfo = book?.getBookRatingInfo(b.id);

                                    return (
                                        <tr
                                            key={b.id}
                                            onClick={() => handleClick(b)}
                                            style={{ cursor: "pointer" }}
                                            className="table-row-hover small"
                                        >
                                            <td className="text-center fst-italic">{index + 1}</td>

                                            <td className="text-start">
                                                {b.title.length > 20 ? `${b.title.slice(0, 20)}...` : b.title}
                                            </td>

                                            <td className="text-start">
                                                {b.subtitle
                                                    ? b.subtitle.length > 40
                                                        ? `${b.subtitle.slice(0, 40)}...`
                                                        : b.subtitle
                                                    : "-"}
                                            </td>

                                            <td className="text-start">
                                                {b.author
                                                    ? b.author.length > 15
                                                        ? `${b.author.slice(0, 15)}...`
                                                        : b.author
                                                    : "-"}
                                            </td>
                                            <td className="text-center fst-italic">{b.lang || "en"}</td>

                                            <td className="text-center fst-italic">
                                                {new Date(b.createdAt).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                }).replace(/ /g, "-")}
                                            </td>

                                            <td className="text-center fst-italic">{b.status || "-"}</td>

                                            <td className="text-center fst-italic">{bookRatingInfo?.totalReviews || "-"}</td>

                                            <td className="text-center fst-italic">
                                                {[...Array(5)].map((_, i) => {
                                                    const fullStars = Math.floor(bookRatingInfo?.successRating || 0);
                                                    const halfStar =
                                                        i === fullStars &&
                                                        bookRatingInfo?.successRating % 1 >= 0.3 &&
                                                        bookRatingInfo?.successRating % 1 <= 0.7;

                                                    const isFilled = i < fullStars;
                                                    const iconClass = isFilled
                                                        ? "bi-star-fill"
                                                        : halfStar
                                                            ? "bi-star-half"
                                                            : "bi-star";

                                                    const iconColor =
                                                        isFilled || halfStar ? "gold" : "lightgray";

                                                    return (
                                                        <i
                                                            key={i}
                                                            className={`bi ${iconClass}`}
                                                            style={{
                                                                color: iconColor,
                                                                fontSize: "10px",
                                                                marginRight: "3px",
                                                            }}
                                                        />
                                                    );
                                                })}
                                                &nbsp;&nbsp;
                                                ({bookRatingInfo?.successRating ?? "-"})
                                            </td>
                                        </tr>
                                    );
                                })}

                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>

            )}
        </>
    );
});

export default BookList;
